import { APIClient, ApiQueryParams, buildApiEndpoint } from '@frontend/api-utils';
import {
    AvailableSlotConstraint,
    AvailableSlotListResponse,
    Slot,
    SlotListResponse,
    SlotQueryParams,
    SlotStateName,
    SlotTriggerName
} from '@frontend/slot/types';
import { SpotListResponse, SpotsQueryParams } from '@frontend/spot/types';
import { TriggerBody } from '@frontend/workflow/types';

export class SlotWorkflowClient extends APIClient {
    public static readonly endpoint = '/slot-api/v1';

    public static async updateSlotState(accountId: string, spotId: string, moduleId: string, slotId: string, state: SlotStateName): Promise<Slot> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/spots/${spotId}/modules/${moduleId}/slots/${slotId}/change-state`, { state });
        return await this.handleResponse<Slot>(response);
    }

    public static async triggerSlotState(accountId: string, slotId: string, trigger: TriggerBody<SlotTriggerName>): Promise<void> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/slots/${slotId}/trigger`, trigger);
        return await this.handleVoidResponse(response);
    }

    public static async postAvailableSpots(
        accountId: string,
        constraints: AvailableSlotConstraint,
        queryParams?: ApiQueryParams<SpotsQueryParams>
    ): Promise<SpotListResponse> {
        const url = buildApiEndpoint(`${this.endpoint}/accounts/${accountId}/available-spots`, queryParams);
        const response = await this.post(url, constraints);
        return await this.handleResponse<SpotListResponse>(response);
    }
    public static async postAvailableSlots(
        accountId: string,
        spotId: string,
        constraints: AvailableSlotConstraint,
        queryParams?: ApiQueryParams<SlotQueryParams>
    ): Promise<AvailableSlotListResponse> {
        const url = buildApiEndpoint(`${this.endpoint}/accounts/${accountId}/spots/${spotId}/available-slots`, queryParams);
        const response = await this.post(url, constraints);
        return await this.handleResponse<AvailableSlotListResponse>(response);
    }
    public static async postPossibleSlots(
        accountId: string,
        spotId: string,
        constraints: AvailableSlotConstraint,
        queryParams?: ApiQueryParams<SlotQueryParams>
    ): Promise<SlotListResponse> {
        const url = buildApiEndpoint(`${this.endpoint}/accounts/${accountId}/spots/${spotId}/possible-slots`, queryParams);
        const response = await this.post(url, constraints);
        return await this.handleResponse<SlotListResponse>(response);
    }
    public static async postFilteredSlots(
        accountId: string,
        spotId: string,
        constraints: AvailableSlotConstraint,
        queryParams?: ApiQueryParams<SlotQueryParams>
    ): Promise<SlotListResponse> {
        const url = buildApiEndpoint(`${this.endpoint}/accounts/${accountId}/spots/${spotId}/filtered-slots`, queryParams);
        const response = await this.post(url, constraints);
        return await this.handleResponse<SlotListResponse>(response);
    }

    public static async fetchSimilarSlots(
        accountId: string,
        spotId: string,
        moduleId: string,
        slotId: string,
        queryParams?: ApiQueryParams<SlotQueryParams>
    ): Promise<AvailableSlotListResponse> {
        const url = buildApiEndpoint(`${this.endpoint}/accounts/${accountId}/spots/${spotId}/modules/${moduleId}/slots/${slotId}/similar-slots`, queryParams);
        const response = await this.fetch(url);
        return await this.handleResponse<AvailableSlotListResponse>(response);
    }
}
